import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';
import { InventoryType } from '../models/inventory-type/inventory-type';

/** Inventory types live in Inventory.API; Finance only reads them (GL account rules key on them). */
@Injectable({ providedIn: 'root' })
export class InventoryTypeProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/inventory-type';

  /** Shared so the list is fetched once per session. */
  private readonly all$ = this.httpClient.get<ApiResponse<InventoryType[]>>(`${this.baseUrl}/all`).pipe(shareReplay(1));

  public getAll(): Observable<ApiResponse<InventoryType[]>> {
    return this.all$;
  }
}
